import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'; 
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxNumberSpinnerModule } from './ngx-number-spinner/ngx-number-spinner.module';
import { PublicComponent } from './layout/public';
import { PrivateComponent } from './layout/private';
import { AuthGuard } from './core/guards/auth.guard';
import { PublicGuard } from './core/guards/public.gaurd';
import { LoaderComponent } from './shared/loader/loader.component';
import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { HomeModule } from './home/home.module';
import { CartModule } from './cart/cart.module';
import { ProductModule } from './product/product.module';
import { ProfileModule } from './profile/profile.module';
import { TestComponent } from './test/test.component';
import { GraphQLModule } from './graphql.module';
import { OrderModule } from './order/order.module';
import { StaticContentModule } from './static-content/static-content.module';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { CookieService } from 'ngx-cookie-service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { HeaderInterceptors } from './core/interceptor/header-interceptor.service';
import { LoaderInterceptor } from './core/interceptor/loader.interceptor';
import { ResponseInterceptors } from './core/interceptor/response-interceptor.service';
import { OfflineInterceptor } from './core/interceptor/offline.interceptor';
import { PromotionModule } from './promotion/promotion.module';
import { RouterModule } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service, RecaptchaV3Module } from 'ng-recaptcha-2';
import { environment } from 'src/environments/environment';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FeedbackModule } from './feedback/feedback.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ConnectivityService } from './shared/services/connectivity.service';
import { NetworkStatusService } from './core/services/networkstatus.service';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname === environment.domainName ? environment.domainName : undefined
  },
  palette: {
    popup: {
      background: "#2BA292",
      text: "#ffffff"
    },
    button: {
      background: "#FDCC49",
      text: "#1F2227",
    }
  },
  theme: 'classic',
  type: 'opt-out',
  content: {
    message: "This website uses cookies to ensure you get the best experience on our website.",
    dismiss: "Got it!",
    deny: "Refuse cookies",
    link: "Learn more",
    href: "https://cookiesandyou.com",
    policy: "Cookie Policy"
  }
};

@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    PrivateComponent,
    LoaderComponent,
    TestComponent,
  ],
  imports: [
    BrowserModule,
    GraphQLModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot({ preventDuplicates: true }),
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    CarouselModule.forRoot(),
    AccordionModule.forRoot(),
    SlickCarouselModule,
    NgxNumberSpinnerModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    RatingModule.forRoot(),
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    UserModule,
    PromotionModule,
    SharedModule,
    HomeModule,
    FeedbackModule,
    CartModule,
    OrderModule,
    StaticContentModule,
    ProductModule,
    ProfileModule,
    RouterModule.forRoot([])
  ],
  providers: [
    // Modern Angular 20 HTTP pipeline with DI-resolved interceptors
    // provideHttpClient(withInterceptorsFromDi()),
    // provideHttpClient(withInterceptors([MyInterceptor])),

    // Guards & services
    AuthGuard,
    PublicGuard,
    CookieService,
    GoogleAnalyticsService,
    ReCaptchaV3Service,
    ConnectivityService,
    NetworkStatusService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OfflineInterceptor,
      multi: true, // Ensure multiple interceptors can be used
    },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptors, multi: true }, 
  
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptors, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },

    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchasiteKey,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}